import script from "./Categories.vue?vue&type=script&setup=true&lang=js"
export * from "./Categories.vue?vue&type=script&setup=true&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=60b13bfa&lang=css"

const __exports__ = script;

export default __exports__